import styled from 'styled-components';

export const TopNavContainer = styled.nav`
	position: absolute;
	top: 0;
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	z-index: 10;
	div {
		display: flex;
		flex-direction: column;
	}
`;

export const Backbutton = styled.div`
	cursor: pointer;
	padding: 1rem;
	font-size: 1.5rem;
	color: var(--ion-color-light-shade);
	ion-icon {
		background-color: #257226;//var(--ion-color-secondary);
		border-radius: 50%;
		border: 2px solid var(--ion-color-light-shade);
		padding: 0.25rem;
	}
`;

export const Morebutton = styled.div`
	cursor: pointer;
	padding: 1rem 1rem 0;
	font-size: 1.5rem;
	color: #fff;
	margin: 0 auto;
`;

export const Bookmarkbutton = styled.div`
	cursor: pointer;
	padding: 1rem;
	font-size: 2rem;
	color: #fff;
	/* color: var(--ion-color-success); */
	transition: color 0.3s ease;
`;
